<template>
    <div class="modal fade" tabindex="-1" ref="infoModal" id="infoModal" aria-labelledby="infoModalLabel">
        <div class="modal-dialog shadow" :class="modalSize">
            <div class="modal-content py-sm-2 px-1 pt-0">
                <div class="modal-header border-0 pt-2 pb-3">
                    <h2 class="modal-title fs-5" v-if="infoModalHeading">{{ infoModalHeading}}</h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-start py-0">
                    <div v-html="infoModalText"></div>
                </div>
                <div class="modal-footer py-0 border-0">
                    <button class="btn btn-primary mb-2" :class="modalSize == 'default' ? 'w-100' : 'mx-auto'" data-bs-dismiss="modal">Okay</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
				infoModalHeading: '',
				infoModalText: '',
                modalSize: 'default'
            }
        },
        mounted() {
			this.emitter.on('openInfoModal', data => {
				this.infoModalHeading = data.heading;
				this.infoModalText = data.text;
                if(data.size) {
                    this.modalSize = data.size;
                }
            });
        }
    }
</script>
<style lang="scss" scoped>
    .modal-dialog {
        &.default {
            width: 300px;
        }
    }
</style>